import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=ab0b2f4c"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=ab0b2f4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports